import api from './api';

const uploadService = {
    // Get user's uploads
    getUploads: async (status) => {
        const params = status ? { status } : {};
        const response = await api.get('/api/uploads', { params });
        return response.data;
    },

    // Get active uploads
    getActiveUploads: async () => {
        const response = await api.get('/api/uploads/active');
        return response.data;
    },

    // Get all uploads (admin only)
    getAllUploads: async (params = {}) => {
        const response = await api.get('/api/uploads/all', { params });
        return response.data;
    },

    // Update upload progress
    updateProgress: async (uploadId, progress, uploadedBytes) => {
        const response = await api.patch(`/api/uploads/${uploadId}/progress`, {
            progress,
            uploadedBytes
        });
        return response.data;
    },

    // Mark upload as complete
    completeUpload: async (uploadId) => {
        const response = await api.patch(`/api/uploads/${uploadId}/complete`);
        return response.data;
    },

    // Mark upload as failed
    failUpload: async (uploadId, errorDetails) => {
        const response = await api.patch(`/api/uploads/${uploadId}/fail`, {
            errorDetails
        });
        return response.data;
    },

    // Retry failed upload (admin only)
    retryUpload: async (uploadId) => {
        const response = await api.post(`/api/uploads/${uploadId}/retry`);
        return response.data;
    },

    // Cleanup stale uploads (admin only)
    cleanupStale: async () => {
        const response = await api.post('/api/uploads/cleanup-stale');
        return response.data;
    },

    // Get incomplete uploads for resumption
    getIncompleteUploads: async () => {
        const response = await api.get('/api/uploads/incomplete');
        return response.data;
    },

    // Upload video to S3 with progress tracking
    uploadToS3: async (signedUrl, file, onProgress) => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            xhr.upload.addEventListener('progress', (event) => {
                if (event.lengthComputable && onProgress) {
                    const progress = Math.round((event.loaded / event.total) * 100);
                    onProgress(progress, event.loaded);
                }
            });

            xhr.addEventListener('load', () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve({ success: true });
                } else {
                    reject(new Error(`Upload failed with status ${xhr.status}`));
                }
            });

            xhr.addEventListener('error', () => {
                reject(new Error('Upload failed'));
            });

            xhr.open('PUT', signedUrl);
            xhr.setRequestHeader('Content-Type', 'video/mp4');
            xhr.send(file);
        });
    }
};

export default uploadService;
